// src/pages/AdminPage.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import AdminDashboard from '../components/admin/AdminDashboard';
import AddJewellery from '../components/admin/AddJewellery';
import JewelleryList from '../components/admin/JewelleryList';
import EditJewellery from '../components/admin/EditJewellery';
import BillingPage from './BillingPage'; // Assuming relative since we are in pages/
// Check path: AdminPage is in src/pages/. BillingPage is in src/pages/. So it is ./BillingPage
import ManageCustomers from '../components/admin/ManageCustomers';
import ViewJewellery from '../components/admin/ViewJewellery';
import LiveGoldRate from '../components/admin/LiveGoldRate';
import BankDetails from '../components/admin/BankDetails';
import Account from '../components/admin/Account';
import SalesList from '../components/admin/SalesList';

import MobileBottomNav from '../components/admin/dashboard/MobileBottomNav';

const AdminPage = () => {
  return (
    <div>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/add-jewellery" element={<AddJewellery />} />
          <Route path="/jewellery-list" element={<JewelleryList />} />
          <Route path="/view-jewellery" element={<ViewJewellery />} />
          <Route path="/edit-jewellery/:id" element={<EditJewellery />} />
          <Route path="/make-bill" element={<BillingPage />} />
          <Route path="/manage-customers" element={<ManageCustomers />} />
          <Route path="/live-gold-rate" element={<LiveGoldRate />} />
          <Route path="/bank-details" element={<BankDetails />} />
          <Route path="/account" element={<Account />} />
          <Route path="/sales" element={<SalesList />} />
        </Routes>
      </div>
      <MobileBottomNav />
    </div>
  );
};

export default AdminPage;
